import React from "react"
import { PeriodoEntregaFornecedorContextProvider } from "./context/PeriodoEntregaFornecedorContextProvider"
import { PeriodoEntregaFornecedor } from "./PeriodoEntregaFornecedor"

export function Index() {
    return (
        <PeriodoEntregaFornecedorContextProvider>
            <PeriodoEntregaFornecedor />
        </PeriodoEntregaFornecedorContextProvider>
    )
}
